import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { ModalProvider } from './components/modalPopup/modelcontext';
import ModalPopUp from './components/modalPopup/modalpopup';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from './services/ssoAuthConfig';

const msalInstance = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

(async () => {
    try {
        await msalInstance.initialize();
        const response = await msalInstance.handleRedirectPromise();

        if (response !== null) {
            msalInstance.setActiveAccount(response.account);
        } else {
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                msalInstance.setActiveAccount(accounts[0]);
            }
            else {
                msalInstance.loginRedirect();
            }
        }

        root.render(
            <React.StrictMode>
                <MsalProvider instance={msalInstance}>
                    <ModalProvider>
                        <App />
                        <ModalPopUp />
                    </ModalProvider>
                </MsalProvider>
            </React.StrictMode>
        );
    } catch (error) {
        console.error("MSAL redirect handling error", error);
    }
})();

reportWebVitals();
